import { createSlice } from "@reduxjs/toolkit";


const initialState = {
 otpCode:"",
 customerId:"",
 isCustomerHasCode:false,
 otpResponse:'',
 mobile:''
};

const OTPSlice = createSlice({
  name: "OTP",
  initialState,

  reducers: {
    setOTP: (state,action) => {
      state.otpCode = action.payload;
 
    },
    setOTPMobile: (state,action) => {
      state.mobile = action.payload;
 
    },
    
    setCustomerId: (state,action) => {
      state.customerId = action.payload;
    },
    setIsCustomerHasCode:(state,action)=>{
       state.isCustomerHasCode=action.payload
    },
    setOtpResponse:(state,action)=>{
       state.otpResponse=action.payload
    },
    clearOTP:()=>{
      return initialState;
    }
  },


});

export const { setOTP,clearOTP,setCustomerId,setIsCustomerHasCode,setOtpResponse,setOTPMobile} = OTPSlice.actions;
export default OTPSlice.reducer;
